import { forwardRef, type Ref, type ReactNode, type HTMLAttributes } from 'react';

export interface AppShellHeaderProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  /** Reduce height visually for compact layouts (override per-instance). */
  withBorder?: boolean;
}

/** Top header bar: pins to `--rr-app-shell-header` height. */
export const AppShellHeader = forwardRef(function AppShellHeader(
  { children, withBorder = true, className, ...rest }: AppShellHeaderProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <header
      ref={ref}
      className={[
        'rr-app-shell__header',
        withBorder && 'rr-app-shell__header--bordered',
        className
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </header>
  );
});
AppShellHeader.displayName = 'AppShellHeader';
